var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqSectionFigmaBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1896,
    height: 844,
    viewBox: "0 0 1896 844",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1499 153.994C1499 25.8674 1602.87 -78 1730.99 -78C1859.12 -78 1962.99 25.8674 1962.99 153.994C1962.99 282.121 1859.12 385.989 1730.99 385.989C1602.87 385.989 1499 282.121 1499 153.994Z",
    fill: "#1E3A5F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-83 689.663C-83 604.245 -13.755 535 71.6629 535C157.081 535 226.326 604.245 226.326 689.663C226.326 775.081 157.081 844.326 71.6629 844.326C-13.755 844.326 -83 775.081 -83 689.663Z",
    fill: "#415496"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9987 161.579C57.9987 157.575 61.2445 154.329 65.2485 154.329C69.2525 154.329 72.4983 157.575 72.4983 161.579C72.4983 165.583 69.2525 168.829 65.2485 168.829C61.2445 168.829 57.9987 165.583 57.9987 161.579Z",
    fill: "#415496"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqSectionFigmaBg);
export default __webpack_public_path__ + "static/media/FaqSectionFigmaBg.87519c21855e2bd6b086fcf6914fddf2.svg";
export { ForwardRef as ReactComponent };